import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import { useQuery} from '@apollo/client';
import gql from "graphql-tag"
import SearchListItems from "../SearchResult/SearchListItems"

const NoResultProperties = (status, department) => {

    const NoResultProperties = gql`
    query NoResultProperties($status: String!, $department: String!){
        properties(limit:6, where:{status:$status, department:$department, publish:true}) {
            id
            bathroom
            bedroom
            reception
            building
            crm_id
            post_code
            display_address
            search_type
            status
            slug
            title
            department
            price
            price_qualifier
            images
            description
            imagetransforms
            office_crm_id
        }
    }`

    const NoResultNewHomesProperties = gql`
    query NoResultProperties($publish: String!){
        newDevelopments(limit:6, where:{publish:$publish}) {
            id
            _id
            slug
            display_address
            street_name
            title
            status
            bedroom
            town
            district
            apartment {
                id
            }
            bungalow{
                id
            }
            house {
                id
            }
            townhouse{
                id
            }
            land {
                id
            }
            area
            search_type
            description
            latitude
            longitude
            additional_description
            search_description
            images {
              url
              alternativeText
            }

            price
            status
            office {
              New_Homes_Email
            }
            brochure {
                url
            }
            meta_title
            meta_description
            imagetransforms
            title
        }
    }`

    const NoResultInternationalProperties = gql`
    query NoResultProperties($publish: String!){
        internationalProperties(limit:6, where:{publish:$publish}) {
            id
            _id
            slug
            display_address
            street_name
            title
            status
            bedroom
            town
            district
            apartment {
                id
            }
            bungalow{
                id
            }
            house {
                id
            }
            townhouse{
                id
            }
            land {
                id
            }
            area
            search_type
            description
            latitude
            longitude
            additional_description
            search_description
            images {
              url
              alternativeText
            }

            price
            status
            office {
              New_Homes_Email
            }
            brochure {
                url
            }
            meta_title
            meta_description
            imagetransforms
            title
        }
    }`

    let qlQuery = NoResultProperties;
    let qlParmas = {status: status, department: department}

    if (department === 'newhomes') {
        qlQuery = NoResultNewHomesProperties;
        qlParmas = {publish: 'true'}
    }else if (department === 'international') {
        qlQuery = NoResultInternationalProperties;
        qlParmas = {publish: 'true'}
    }
    

    return useQuery(qlQuery, {
        variables: qlParmas
    });
}

const NoResultList = (props) => {

  const[department, setDepartment] = useState(props?.department || 'residential');

  // useEffect(()=>{
  //   props.department && setDepartment(props.department);
  // },[props.department]);

  const {loading:loading, error:error, data:data} = NoResultProperties(props.status, department);

  if (loading) return null;

  return (
    <React.Fragment>
        <SearchListItems noResult={true} hits={data?.properties || data?.newDevelopments ||  data?.internationalProperties} source={`strapi`} department={department}/>
    </React.Fragment>
  );
};

export default NoResultList;
